/* ==============================================================================================
 * CROSSBROWSER WINDOW RESIZE TRIGGER
 * ============================================================================================== */

var Sushi;

(function (Sushi) {
	"use strict";

	/**
	 * Triggers a window resize event
	 *
	 * @return {void}
	 */
	Sushi.Util.triggerWindowResize = function () {
		var resizeEvent = window.document.createEvent("UIEvents");

		resizeEvent.initUIEvent("resize", true, false, window, 0);
		window.dispatchEvent(resizeEvent);
	};

})(Sushi || (Sushi = {}));
